import { BoxInfos } from './box-infos';
import { BoxGroup } from './server/box-group';

export class BoxGroupInfos extends BoxGroup {
    public selected: boolean;
    public override boxes: BoxInfos[] = [];

    public constructor(boxGroup: BoxGroup) {
        super();
        this.id = boxGroup.id;
        this.name = boxGroup.name;
        this.order = boxGroup.order;
        this.boxes = [];

        boxGroup.boxes.forEach((b) => this.boxes.push(new BoxInfos(b)));
        this.selected = false;
    }
}
